
import { defineComponent } from 'vue'
import Board from './components/Board.vue'
import Modal from './components/Modal.vue'

export default defineComponent({
	name: 'App',
	components: {
		Board,
		Modal,
	},
	data: () => ({
		gameState: 'level-select',
		mode: 'open',
		interval: 0,
		timer: 0,
		moveCount: 0,
	}),
	methods: {
		memorizeStart: function(mode: string) {
			this.mode = mode
			this.gameState = 'memorize'
		},
		playingStart: function() {
			this.gameState = 'playing'
		},
		countUp: function() {
			this.moveCount++
		},
		finish: function() {
			this.gameState = 'finish'
		},
		retry: function() {
			this.gameState = 'memorize'
		},
		levelChange: function() {
			this.gameState = 'level-select'
		},
		tweet: function() {
			let text = ''
			if (this.gameState === 'finish') {
				// クリアした場合の文言
				if (this.mode === 'hidden') text += "「すべて隠す」を "
				if (this.mode === 'even') text += "「半分を隠す」を "
				if (this.mode === 'open') text += "「隠さない」を "
				text += this.timer / 10 + " 秒、 " + this.moveCount + " 手でクリアしました！\n\n"
			}
			text += "目隠しスライドパズル"

			const encoded = encodeURIComponent(text)
			const url = "https://twitter.com/intent/tweet?text=" + encoded + "&url="+ document.location
			window.open(url)
		}
	},
	watch: {
		gameState: function(newValue, oldValue) {
			if (newValue === 'memorize') {
				this.timer = 0
				this.moveCount = 0
			}
			if (newValue === 'playing') {
				this.interval = setInterval( () => {
					this.timer++
				}, 100)
			}
			if (oldValue === 'playing') {
				clearInterval(this.interval)
			}
		}
	},
	computed: {
		timerStr: function() {
			if (this.timer % 10 === 0) {
				return this.timer / 10 + '.0'
			} else {
				return this.timer / 10
			}
		}
	}
})
